/**
 * Currency utilities for SpellBook
 * Centralized currency symbol mapping and formatting
 */

export const getCurrencySymbol = (currency?: string): string => {
  const currencyMap: { [key: string]: string } = {
    'USD': '$',
    'EUR': '€',
    'RUB': '₽',
    'GBP': '£',
    'BYN': 'Br',
    'JPY': '¥',
    'CNY': '¥',
    'KRW': '₩',
    'INR': '₹',
  };
  return currencyMap[currency?.toUpperCase() || 'USD'] || '$';
};

export const formatCurrency = (amount: number, currency?: string): string => {
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${amount.toLocaleString()}`;
};

